import React from "react";
import { Link } from 'react-router-dom';
import blckslogo from '../assets/icons/BLCKS_LOGO_NEW.svg';
import githubicon from '../assets/icons/github.svg';
import linkedinicon from '../assets/icons/linkedin.svg';
import xicon from '../assets/icons/x.svg';
import maildark from '../assets/contact/mail_dark.svg';

const Footer = () => {
  const productLinks = [
    "Consulting",
    "Sales Block",
    "Office Block",
    "Insight Block",
    "Service Block"
    // Placeholder links (commented out for future use):
    // "XXX",
    // "XXX",
    // "XXX"
  ];

  const companyLinks = [
    { text: "Über uns", link: "/about" },
    { text: "Presse & News", link: "#" },
    { text: "Preise", link: "/pricing" },
    { text: "Karriere", link: "#" },
    { text: "Kontakt", link: "/contact" }
  ];

  const resourceLinks = [
    { text: "FAQ", link: "/faq" },
    { text: "Blog", link: "/blog" },
    { text: "KI-News", link: "#" },
    { text: "Tools & Links", link: "#" },
    { text: "Fallstudien", link: "#" },
    { text: "KI Förderungen", link: "#" },
    { text: "KI Online Audit", link: "https://audit.blcks.at" }
  ];

  const bottomLinks = [
    { text: "Impressum", link: "/impressum" },
    { text: "Datenschutzrichtlinie", link: "/datenschutz" },
    { text: "Cookie-Richtlinie", link: "/cookie-richtlinie" },
    {
      text: "Cookie Einstellungen",
      link: "#",
      onClick: (e) => {
        e.preventDefault();
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new Event('showCookieConsentDialog'));
        }
      }
    },
    { text: "AGB", link: "/agb" }
  ];

  return (
    <footer className="relative overflow-hidden pt-14 px-4 pb-12 sm:pt-12">
      {/* Frosted glass overlay */}
      {/*<div className="absolute inset-0 bg-[#010003]/80 backdrop-blur-lg backdrop-saturate-150" />*/}
      <div className="absolute inset-0 bg-[#010003]/0" />

      {/* Frosted glass border effect */}
      <div
        className="absolute inset-0"
        style={{
          maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
          WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        }}
      />
      {/*<span 
        className="absolute left-0 top-0 z-10 h-px w-full" 
        style={{
          background: 'linear-gradient(90deg, transparent 0%, rgba(120, 124, 135, 0.25) 15%, rgba(120, 124, 135, 0.25) 85%, transparent 100%)',
          height: '1px'
        }} 
        aria-hidden="true" 
      />*/}

      <div className="max-w-[1408px] mx-auto px-8 relative z-10">
        {/* Desktop Layout - Original layout */}
        <div className="flex justify-between w-full relative">
          {/* Left Column - Logo and social */}
          <div className="w-[252px] flex flex-col justify-between" style={{ minHeight: 'calc(291px + 24px + 24px)' }}>
            <Link to="/" className="block w-fit">
              <img
                src={blckslogo}
                alt="BLCKS Logo"
                className="h-8 w-auto"
              />
            </Link>

            <div className="flex gap-x-7">
              <a href="https://www.linkedin.com/in/philippfuchs-blcks" aria-label="LinkedIn" rel="noopener noreferrer" target="_blank">
                <img src={linkedinicon} alt="LinkedIn" className="w-6 h-6" />
              </a>
              {/*<a href="https://x.com/blcksai" aria-label="X" rel="noopener noreferrer" target="_blank">
                <img src={xicon} alt="X" className="w-6 h-6" />
              </a>*/}
              {/*<a href="https://github.com/blcksdev" aria-label="GitHub" rel="noopener noreferrer" target="_blank">
                <img src={githubicon} alt="GitHub" className="w-6 h-6" />
              </a>*/}
            </div>
          </div>

          {/* Email Button - Positioned within the main container */}
          <div className="absolute right-0 -bottom-3 z-20">
            <a
              href="mailto:hello@blcks.at"
              className="transition-shadow duration-300 group inline-flex items-center relative justify-center rounded-full tracking-tight h-10 text-16 px-5 bg-white text-[#0d0e12] font-medium w-fit shadow-[0px_6px_16px_rgba(255,255,255,.2)] hover:shadow-[0px_6px_56px_0px_rgba(255,255,255,.4),0px_4px_15px_0px_rgba(0,0,0,.2)]"
            >
              <span
                className="pointer-events-none absolute inset-0 z-0 rounded-[inherit] bg-gradient-to-r from-white to-gray-200 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                aria-hidden="true"
              />
              <img
                src={maildark}
                alt=""
                className="relative z-10 h-5 w-5 mr-3"
                width={18}
                height={18}
              />
              <span className="relative z-10 text-[#0d0e12] font-geist font-normal">hello@blcks.at</span>
            </a>
          </div>

          {/* Right Column - Navigation Links */}
          <div className="flex-1">
            <div className="flex justify-end" style={{ gap: '136px' }}>
              {/* Product Links */}
              <div className="w-auto">
                <h3 className="font-['Geist',Helvetica] font-medium text-white text-[15px] tracking-[-0.32px] leading-[19.5px] mb-5">
                  Lösungen
                </h3>
                <div className="flex flex-col" style={{ gap: '1rem' }}>
                  {productLinks.map((link, index) => (
                    <a
                      key={`product-${index}`}
                      href="#"
                      className="font-['Geist',Helvetica] font-light text-[#adb0b9] text-[15px] tracking-[-0.32px] leading-[15px] hover:text-white transition-colors"
                    >
                      {link}
                    </a>
                  ))}
                </div>
              </div>

              {/* Company Links */}
              <div className="w-auto">
                <h3 className="font-['Geist',Helvetica] font-medium text-white text-[15px] tracking-[-0.32px] leading-[19.5px] mb-5">
                  Unternehmen
                </h3>
                <div className="flex flex-col" style={{ gap: '1rem' }}>
                  {companyLinks.map((link, index) => (
                    link.link.startsWith('http') || link.link === '#' ? (
                      <a
                        key={`company-${index}`}
                        href={link.link}
                        className="font-['Geist',Helvetica] font-light text-[#adb0b9] text-[15px] tracking-[-0.32px] leading-[15px] hover:text-white transition-colors"
                      >
                        {link.text}
                      </a>
                    ) : (
                      <Link
                        key={`company-${index}`}
                        to={link.link}
                        className="font-['Geist',Helvetica] font-light text-[#adb0b9] text-[15px] tracking-[-0.32px] leading-[15px] hover:text-white transition-colors"
                      >
                        {link.text}
                      </Link>
                    )
                  ))}
                </div>
              </div>

              {/* Resources Links */}
              <div className="w-auto">
                <h3 className="font-['Geist',Helvetica] font-medium text-white text-[15px] tracking-[-0.32px] leading-[19.5px] mb-5">
                  Ressourcen
                </h3>
                <div className="flex flex-col" style={{ gap: '1rem' }}>
                  {resourceLinks.map((link, index) => (
                    link.link.startsWith('http') ? (
                      <a
                        key={`resource-${index}`}
                        href={link.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-['Geist',Helvetica] font-light text-[#adb0b9] text-[15px] tracking-[-0.32px] leading-[15px] hover:text-white transition-colors"
                      >
                        {link.text}
                      </a>
                    ) : (
                      <Link
                        key={`resource-${index}`}
                        to={link.link}
                        className="font-['Geist',Helvetica] font-light text-[#adb0b9] text-[15px] tracking-[-0.32px] leading-[15px] hover:text-white transition-colors"
                      >
                        {link.text}
                      </Link>
                    )
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom section */}
        <div className="w-full max-w-[1344px] mx-auto mt-0 pt-10">
          <div className="flex flex-wrap justify-center gap-6 pt-6 border-t border-[#2a2b2e] md:justify-between">
            <p className="text-[#6e6f73] text-sm">
              &copy; {new Date().getFullYear()} blcks, Designed and Built by{' '}
              <a
                href="https://blcks.at/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#6e6f73] hover:text-white transition-colors"
              >
                blcks
              </a>
            </p>
            <div className="flex gap-6">
              {bottomLinks.map((link, index) =>
                link.onClick ? (
                  <a
                    key={`bottom-${index}`}
                    href="#"
                    onClick={link.onClick}
                    className="text-[#6e6f73] hover:text-white text-sm transition-colors"
                  >
                    {link.text}
                  </a>
                ) : (
                  <Link
                    key={`bottom-${index}`}
                    to={link.link}
                    className="text-[#6e6f73] hover:text-white text-sm transition-colors"
                  >
                    {link.text}
                  </Link>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;